// <div data-controller="components--top-banner">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";

export default class extends Controller {
  static targets = [ "" ];
  static values = {
    dismissKey: String,
    noticeId: Number
  };

  dismiss() {
    api.post("/api/faces/dismiss", {
      dismiss_key: this.dismissKeyValue
    })
  }

  dismissNotice() {
    api.post("/api/notices/dismiss", { notice_id: this.noticeIdValue })
  }

  connect() {
  }
}